import {useEffect,useState} from 'react'
import {Route,Switch,useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify';
import { useDispatch,useSelector } from "react-redux";

import Header from "./containers/Header/Header";
import Header2 from "./containers/Header/Header2";
import Footer from "./containers/Footer/Footer";
import Footer2 from "./containers/Footer/Footer2";
import NotFound from './containers/NotFound/NotFound';
import MainBox from "./containers/MainBox/MainBox";
import Warranty from './containers/Warranty/Warranty';
import Test from './containers/Common/Test';
import FillInfo from './containers/Packages/FillInfo';
import CheckPhone from './containers/CheckPhone/CheckPhone';
import ServiceTop from './containers/Packages/ServiceTop'
import ServiceBottom from './containers/Packages/ServiceBottom';
import ServiceShow from './containers/Packages/ServiceShow';
import EquipmentShow from './containers/Packages/EquipmentShow';
import Payment from './containers/Packages/Payment';
import Callback from './containers/Callback/Callback';
import FinalPage from './containers/Callback/FinalPage';
import { updateCustomer } from "./ReduxActions/customerAction";
import { getData } from "./containers/Services/APIService";
import config from "./containers/Services/config.json";
import ReactGA from 'react-ga';
import RouteChangeTracker from './RouteChangeTracker'
import { Modal } from 'react-responsive-modal';

function App() {
  
  const [showPopup,setShowPopup] = useState(false);
  const [txtPopup,setTxtPopup] = useState('');
  const [isMobile,setIsMobile] = useState(false);

  const customer = useSelector(state => state.customer);
  const dispatch = useDispatch();
  let location = useLocation();

  ReactGA.initialize("UA-59401146-1");

  useEffect(() => {
    async function fetchMyAPI() {
      if(location.pathname === "/"){
        let search = window.location.search;
        let params = new URLSearchParams(search);
        var presenter=params.get('presenter');
        if(presenter && presenter!=""){
          const info={
            token: config.APIKey,
            Presenter:presenter
          };
          const {data}=await getData('store/getPresenterUserName',info);
          
          if(data.Presenter!=null && data.Presenter!=''){
            dispatch(updateCustomer({Presenter:data.Presenter,Know:1}));
            if( data.PresenterMessage!=''){
              setShowPopup(true);
              setTxtPopup(data.PresenterMessage);
            }
          }
        }
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    fetchMyAPI();

    //Original URL
    let savedReferrer = localStorage.getItem("originalReferrer");
    if (!savedReferrer) {
      savedReferrer = document.referrer;
      
      if(savedReferrer!=undefined && savedReferrer!=null)
        localStorage.setItem("originalReferrer", savedReferrer);
    }

  }, [])

  const handleResize=()=>{
      var width=window.innerWidth;

      if(width<577){
        dispatch(updateCustomer({isMobile0:true}));
        setIsMobile(true);
      }
      else{
        dispatch(updateCustomer({isMobile0:false}));
        setIsMobile(false);
      }

      if(width<656){
          dispatch(updateCustomer({isMobile:true}));
          setIsMobile(true);
      }
      else{
        dispatch(updateCustomer({isMobile:false}));
        setIsMobile(false);
      }

      if(width<730){
        dispatch(updateCustomer({isTablet:true}));
      }
      else{
        dispatch(updateCustomer({isTablet:false}));
      }

      if(width<950){
        dispatch(updateCustomer({isTablet2:true}));
      }
      else{
        dispatch(updateCustomer({isTablet2:false}));
      }
  }

  return (
    <div className="App">
        <Modal classNames={{modal:"modal"}} open={showPopup} onClose={() => setShowPopup(false)} center>
            <div className="modalIconP">
              <div className="modalIcon">
                <label className="fa fa-info"></label>
              </div>
            </div>
            <label className="modalTitle">دوست گرامی</label>
            <div className="modalBody">
              <label className="modalLabel">
                  {txtPopup}
              </label>
            </div>
        </Modal>
         <RouteChangeTracker />
         <Switch>
            <Route path="/" exact render={() =>
                <>
                  <Header/>
                  <div className="content">
                      <MainBox serviceType={-1} />
                      <MainBox serviceType={0} />
                      {/* {!isMobile && <Warranty />} */}
                      <MainBox serviceType={2} />
                      <MainBox serviceType={3} />
                      <MainBox serviceType={1} />
                      <MainBox serviceType={4} />
                      {/* {isMobile && <Warranty />} */}
                      <Warranty />
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/checkPhone" render={() =>
                <>
                  <Header/>
                  <div className="content">
                    <div className="subContent">
                      <ServiceTop serviceType={1} step={1}></ServiceTop>
                      <CheckPhone/>
                      <ServiceBottom serviceType={1} step={1}></ServiceBottom>
                    </div>
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/serviceShow" render={() =>
                <>
                  <Header/>
                  <div className="content">
                    <div className="subContent">
                      <ServiceTop serviceType={customer.serviceType} step={customer.serviceType != 1 ? 1 : 2}></ServiceTop>
                      {
                        customer.serviceType === 1 ?
                          <>
                          <ServiceShow serviceType={customer.serviceType} modem={2} tag={4}></ServiceShow>{/* برای نمایش پیشنهاد ویژه ها */}
                          <ServiceShow serviceType={customer.serviceType} modem={1} tag={-1}></ServiceShow>
                          <ServiceShow serviceType={customer.serviceType} modem={0} tag={-1}></ServiceShow>
                          </>
                        :(
                        customer.serviceType === 2 ?
                          <>
                          <ServiceShow serviceType={customer.serviceType} modem={1} tag={0}></ServiceShow>
                          <ServiceShow serviceType={customer.serviceType} modem={0} tag={0}></ServiceShow>
                          </>
                        :
                          <ServiceShow serviceType={customer.serviceType} modem={2} tag={0}></ServiceShow>
                        )
                      }
                      <ServiceBottom serviceType={customer.serviceType} step={customer.serviceType != 1 ? 1 : 2}></ServiceBottom>
                    </div>
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/equipmentShow" render={() =>
                <>
                  <Header/>
                  <div className="content">
                    <div className="subContent">
                      <ServiceTop serviceType={customer.serviceType} step={customer.serviceType != 1 ? 0 : 3}></ServiceTop>
                      <EquipmentShow></EquipmentShow>
                      <ServiceBottom serviceType={customer.serviceType} step={customer.serviceType != 1 ? 0 : 3}></ServiceBottom>
                    </div>
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/fillInfo" render={() =>
                <>
                  <Header2/>
                  <div className="content">
                    <div className="subContent">
                        <ServiceTop serviceType={customer.serviceType} step={customer.serviceType != 1 ? 2 : 3}></ServiceTop>
                        <FillInfo/>
                        <ServiceBottom serviceType={customer.serviceType} step={customer.serviceType != 1 ? 2 : 3}></ServiceBottom>
                    </div>
                  </div>
                  <Footer2/>
                </>
                }
            />
            <Route path="/payment" render={() =>
                <>
                  <Header2/>
                  <div className="content">
                    <div className="subContent">
                      <ServiceTop serviceType={customer.serviceType} step={customer.serviceType != 1 ? 3 : 4}></ServiceTop>
                      <Payment></Payment>
                      <ServiceBottom serviceType={customer.serviceType} step={customer.serviceType != 1 ? 3 : 4}></ServiceBottom>
                    </div>
                  </div>
                  <Footer2/>
                </>
                }
            />
            <Route path="/callback" render={() =>
                <>
                  <Header/>
                  <div className="content">
                    <div className="subContent">
                      <Callback/>
                    </div>
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/finalpage" render={() =>
                <>
                  <Header/>
                  <div className="content">
                    <div className="subContent">
                      <FinalPage/>
                    </div>
                  </div>
                  <Footer/>
                </>
                }
            />
            <Route path="/test" render={() =>
                <Test/>
                }
            />
            <Route path="*" exact component={NotFound} />
        </Switch>
        <ToastContainer/>
    </div>
  );
}

export default App;
